import Vue from "vue";
const getDefaultState = () => {
  return {
    projets: [],
    projetData: [],
    projetSelected: [],
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE_PROJETS(state, payload) {
    state.projets = payload;
  },
  SET_PROJECT_SELECTED(state, payload) {
    state.projetSelected = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async getListeProjets({ commit }) {
    // start requête

    commit("Loading/START_BUSY_STATE", "Projets getListeProjets", {
      root: true,
    });

    let elems = [];

    try {
      await this._vm.$firebase
        .firestore()
        .collection("projets")
        .orderBy("ll_programme", "asc")
        .get()
        .then((snapshot) => {
          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste");
          } else {
            console.log("tout est synchronisé dans projets");
          }

          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              //console.log("New Doc: ", change.doc.data());
              elems.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
            }
            if (change.type === "modified") {
              let obj = elems.find((search) => search.id === change.doc.id);

              //bailleurs
              obj.name = change.doc.data().abbr_bailleur;
              obj.title = change.doc.data().ll_bailleur;
              obj.ll_bailleur = change.doc.data().ll_bailleur;
              obj.abbr_bailleur = change.doc.data().abbr_bailleur;
            }
            if (change.type === "removed") {
              console.log("Removed : ", change.doc.data());
              let obj = elems.find((search) => search.id === change.doc.id);
              const index = elems.indexOf(obj);
              Vue.delete(elems, index);
              //deleteProjetsDeBailleurs
            }
          });
          commit("Loading/END_BUSY_STATE", "projets.store.js", { root: true });
          commit("SET_LISTE_PROJETS", elems);
        });
    } catch (err) {
      console.log("Error getting collection items", err);
    }
    //end requête
  },
  async deleteProjetsDeBailleurs({ commit }, bailleur) {
    console.log("deleteProjetsDeBailleurs: " + bailleur);
  },
  setProjectSelected({ commit }, objet) {
    let ref = this._vm.$firebase
      .firestore()
      .collection("users")
      .doc(objet.userId);
    ref
      .update({
        projetSelected: objet.project,
      })
      .then(function () {
        console.log("Document successfully updated!");
        commit("SET_PROJECT_SELECTED", objet.project);
      })
      .catch(function (error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });
  },
};

const getters = {
  projets: (state) => {
    return state.projets;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
